import {InviteInterface} from "../interfaces/meetings/InviteInterface";
import {setDates} from "../helpers/DatesSetter";
import {ParticipantInterface} from "../interfaces/meetings/ParticipantInterface";
import {Participant} from "../meetings/Participant";
import {DateTime} from "luxon";

export class Invite implements InviteInterface {
    allParticipantsCount = 0;
    beginAt?: DateTime = undefined;
    endAt?: DateTime = undefined;
    eventId = '';
    id = '';
    isActive = false;
    meetingId= '';
    ownerId = 0;
    participants: Participant[] = [];
    title = '';
    userId = 0;

    private dates: string[] = ['beginAt', 'endAt', 'createdAt', 'updatedAt'];

    constructor(data: InviteInterface) {
        Object.assign(this, data);
        setDates(this, this.dates);
        if (this.participants) {
            this.participants = this.participants.map((item: ParticipantInterface) => new Participant(item));
        }
        else {
            this.participants = [];
        }
    }

}